import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const ImageLinkItemSchema = buildEntrySchemaFor('imageLinkItem', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      heading: RichTextSchema,
      description: RichTextSchema,
      href: z.string(),
      label: z.string(),
      image: AssetSchema,
    }),
  ),
})
export type ImageLinkItem = z.infer<typeof ImageLinkItemSchema>
